import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { ConfigManager, FHIRService, ProfileManager, fhirDataFormatter } from '@kailona/core';

var getRelatedPatients = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(patientFhirService, relatedPersons) {
    var promises, responses;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!relatedPersons || !relatedPersons.length)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", []);

          case 2:
            promises = [];
            relatedPersons.forEach(function (relatedPerson) {
              var patient = relatedPerson.patient,
                  relationship = relatedPerson.relationship; // TODO: pass relationship

              var _patient$reference$sp = patient.reference.split('/'),
                  _patient$reference$sp2 = _slicedToArray(_patient$reference$sp, 2),
                  patientId = _patient$reference$sp2[1];

              if (!patientId) {
                return;
              }

              var promise = patientFhirService.read(patientId);
              promises.push(promise);
            });
            _context.next = 6;
            return Promise.all(promises);

          case 6:
            responses = _context.sent;
            return _context.abrupt("return", responses.map(function (res) {
              return res.data;
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getRelatedPatients(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default function initFHIRPatients() {
  return _initFHIRPatients.apply(this, arguments);
}

function _initFHIRPatients() {
  _initFHIRPatients = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ConfigManager$appCon, appUserId, appUserName, patientFhirService, _yield$patientFhirSer, patientBundle, _patientBundle$entry$, patient, relatedPersons, relatedPatients, _yield$patientFhirSer2, patientResource;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ConfigManager$appCon = ConfigManager.appConfig.currentUser, appUserId = _ConfigManager$appCon.id, appUserName = _ConfigManager$appCon.name;
            patientFhirService = new FHIRService('Patient'); // Set app user id

            ProfileManager.userId = appUserId;
            _context2.next = 5;
            return patientFhirService.search([{
              identifier: appUserId,
              _include: 'Patient:link'
            }]);

          case 5:
            _yield$patientFhirSer = _context2.sent;
            patientBundle = _yield$patientFhirSer.data;

            if (!(patientBundle && patientBundle.entry && patientBundle.entry.length)) {
              _context2.next = 16;
              break;
            }

            // Set active fhir patient id
            _patientBundle$entry$ = patientBundle.entry.find(function (e) {
              return e.resource.resourceType === 'Patient';
            }), patient = _patientBundle$entry$.resource;
            ProfileManager.activePatientId = patient.id; // Get fhir patient profiles

            relatedPersons = patientBundle.entry.filter(function (e) {
              return e.resource.resourceType === 'RelatedPerson';
            }).map(function (p) {
              return p.resource;
            });
            _context2.next = 13;
            return getRelatedPatients(patientFhirService, relatedPersons);

          case 13:
            relatedPatients = _context2.sent;
            ProfileManager.profiles = [patient].concat(_toConsumableArray(relatedPatients)).map(function (p) {
              return {
                patientId: p.id,
                patientFullName: fhirDataFormatter.formatPatientName(p.name),
                patientDob: p.birthDate,
                relationship: p.id === patient.id ? t('ehr', 'self') : fhirDataFormatter.formatCodeableConcept(p.relationship)
              };
            });
            return _context2.abrupt("return", false);

          case 16:
            _context2.next = 18;
            return patientFhirService.create({
              resourceType: 'Patient',
              identifier: [{
                use: 'usual',
                value: appUserId
              }],
              active: true,
              name: [{
                given: [appUserName]
              }]
            });

          case 18:
            _yield$patientFhirSer2 = _context2.sent;
            patientResource = _yield$patientFhirSer2.data;
            // Set active fhir patient id and profiles
            ProfileManager.activePatientId = patientResource.id;
            ProfileManager.profiles = [patientResource].map(function (p) {
              return {
                patientId: p.id,
                patientFullName: fhirDataFormatter.formatPatientName(p.name),
                relationship: t('ehr', 'self')
              };
            });
            return _context2.abrupt("return", true);

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _initFHIRPatients.apply(this, arguments);
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getRelatedPatients, "getRelatedPatients", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/lib/initFHIRPatients.js");
  reactHotLoader.register(initFHIRPatients, "initFHIRPatients", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/lib/initFHIRPatients.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();